import { render } from "./ClientPublication.vue?vue&type=template&id=bb78e792"
import script from "./ClientPublication.vue?vue&type=script&lang=js"
export * from "./ClientPublication.vue?vue&type=script&lang=js"

import "./ClientPublication.vue?vue&type=style&index=0&id=bb78e792&lang=scss"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__